// extracted by mini-css-extract-plugin
module.exports = {"container":"noticeCard_container__81BQf"};